/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { mobileOrderItemCreateRequestSchema } from "./mobileOrderItemCreateRequestSchema.ts";

export const mobileOrderExtendRequestSchema = z.object({
	items: z.array(mobileOrderItemCreateRequestSchema),
	table: z.uuid().nullable(),
});
